import api, { omniChannelApi } from '.';
import logger from '../utils/logger';
import { Category } from '../types/categories';
import { SpecificationFilter, SpecificationFiltersResponse } from '../types/filters';
import { transformCategoryResponse } from '../utils/categories';

export const getCategories = async (): Promise<Category[]> => {
  try {
    const { data } = await omniChannelApi.get('/webflow/collections/categories/items?take=500');
    return transformCategoryResponse(data);
  } catch (error) {
    logger('error', 'at getCategories while fetching categories', error);
    throw new Error('at getCategories while fetching categories');
  }
};

export const getSpecificationFilters = async (
  categoryId: number,
  filters?: SpecificationFilter[] | null,
): Promise<SpecificationFiltersResponse> => {
  try {
    const { data } = await api.post(`/rental-equipment-search/equipment-classes/filters`, {
      filter_by: {
        'category-id': parseInt(categoryId.toString()),
        ...(filters && filters.length > 0 && { 'spec-filter': filters }),
      },
    });
    return data;
  } catch (error) {
    logger('error', 'at getFiltersForCategory while fetching filters', error);
    throw new Error('at getFiltersForCategory while fetching filters');
  }
};
